import { transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { ProductObservable } from '../../models/product.model';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  animations: [
    trigger('blockInitialRenderAnimation', [transition(':enter', [])])
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductListComponent implements OnInit, OnDestroy {

  private subscriptions = new Map<string, Subscription>();

  @Input() products$: Observable<ProductObservable[]>;
  @Input() loading$;
  @Input() refreshing$;
  @Input() readOnly = false;
  @Input() expandAll$: Observable<boolean>;
  locale: string;
  disableAnimation = false;

  constructor(
    private translate: TranslateService,
  ) { }

  ngOnInit() {

    // disable animations for long lists
    this.subscriptions.set('disableAnimations',
      this.products$.subscribe(products => {
        this.disableAnimation = products && products.length > 10;
      })
    );

    // language changes
    this.subscriptions.set('translationLanguageChanged',
      this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
        this.locale = event.lang;
      })
    );

  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  trackByCode = (index: number, item: ProductObservable) => item.code;

}
